import { template } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { Col, Row } from 'styles/components/layout'

import {
  Wrapper,
  IconWrapper,
  IconBox,
  BoxBaseStyled,
  IconText,
  IconDescription,
  TextDisclaimerNew,
  ColStyled,
} from './styles'

const CartDeliveryInfoNew = ({
  info,
  disclaimer,
  isCartInitOrUpdate,
  deliveryConfig,
}) => {
  const parseDescription = React.useCallback(
    text => {
      const compileTitle = template(text)
      const placeholder = isCartInitOrUpdate && '...'
      return compileTitle({
        from: placeholder || deliveryConfig?.from,
        to: placeholder || deliveryConfig?.to,
      })
    },
    [isCartInitOrUpdate, deliveryConfig],
  )

  return (
    <BoxBaseStyled>
      <Row justifyContent={{ md: 'space-between' }}>
        {info &&
          info.list &&
          info.list.map((item, idx) => (
            <ColStyled key={idx} width={{ xs: 1, md: 1 / 2, lg: 5 / 12 }}>
              <IconBox>
                <Icon id={item.icon} color="black" />
              </IconBox>
              <IconText dangerouslySetInnerHTML={{ __html: item.title }} />
              <IconDescription
                dangerouslySetInnerHTML={{
                  __html: parseDescription(item.description),
                }}
              />
            </ColStyled>
          ))}
      </Row>
      <Row>
        <Col width={{ xs: 1 }}>
          <Wrapper>
            <IconWrapper>
              <Icon id="btn_info" color="black" />
            </IconWrapper>
            <TextDisclaimerNew
              dangerouslySetInnerHTML={{ __html: disclaimer }}
            />
          </Wrapper>
        </Col>
      </Row>
    </BoxBaseStyled>
  )
}

CartDeliveryInfoNew.propTypes = {
  info: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        icon: PropTypes.string,
      }),
    ),
  }),
  disclaimer: PropTypes.string.isRequired,
  isCartInitOrUpdate: PropTypes.bool.isRequired,
  deliveryConfig: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
  }),
}

export default React.memo(CartDeliveryInfoNew)
